<template>
  <div class="footer-box">
    <footer v-if="region == 'cn'" class="cloud_footer_box">
      <div class="cloud_footer">
        <!-- logo_footer -->
        <div class="cloud_footer_logo">
          <div class="logo-content">
            <a :href="url + '/indexs.html'"
              ><img src="./images/foterlogo.svg" alt=""
            /></a>
            <div class="logo-code">
              <img src="./images/erweima.jpg" alt="" />
            </div>
            <P>{{ $t("footer.scan.follow") }}</P>
          </div>
        </div>

        <!-- footer_nav -->
        <nav class="cloud_footer_nav">
          <!-- 快速链接 -->
          <ul class="cloud_nav_list">
            <li class="cloud_nav_title">{{ $t("footer.quick.links") }}</li>
            <li class="cloud_nav_item">
              <a :href="url + '/whyCloudcc.html'">{{
                $t("footer.why.cloudcc")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/zhongtai/shouye.html'">{{
                $t("footer.business.platform")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/app/jicheng.html'">{{
                $t("footer.integration")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/develoeper/developer.html'">{{
                $t("footer.paas.platform")
              }}</a>
            </li>
            <!-- <li class="cloud_nav_item"><a href="./app/appStore.html">应用商城</a></li> -->
            <li class="cloud_nav_item">
              <a :href="url + '/case/index.html'">{{
                $t("footer.case.center")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/dataSecurity.html'">{{
                $t("footer.data.security")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/develoeper/GDPR.html'">{{
                $t("footer.gdpr.compliance")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a
                target="_blank"
                href="https://informations.cloudcc.com/policy/terms-zh.html"
                >{{ $t("footer.service.agreement") }}</a
              >
            </li>
            <li class="cloud_nav_item">
              <a
                target="_blank"
                href="https://informations.cloudcc.com/policy/PrivacyPolicy-zh.html"
                >{{ $t("footer.privacy.statement") }}</a
              >
            </li>
            <li class="cloud_nav_item">
              <a
                target="_blank"
                href="https://informations.cloudcc.com/policy/app_permissions.html"
                >{{ $t("footer.app.permissions") }}</a
              >
            </li>
          </ul>
          <!-- 产品与价格 -->
          <ul class="cloud_nav_list">
            <li class="cloud_nav_title">{{ $t("footer.products.prices") }}</li>
            <li class="cloud_nav_item">
              <a :href="url + '/sale-cloud/salecloud.html'">{{
                $t("footer.sales.cloud")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/services-cloud/servicescloud.html'">{{
                $t("footer.customer.service.cloud")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/sale-cloud/spot.html'">{{
                $t("footer.field.service.cloud")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/market-cloud/marketcloud.html'">{{
                $t("footer.marketing.cloud")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/prm-cloud/prmcloud.html'">{{
                $t("footer.partner.cloud")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/pro/Project.html'">{{
                $t("footer.project.cloud")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/chatter/chatter.html'">{{
                $t("footer.social.cloud")
              }}</a>
            </li>
            <!-- <li class="cloud_nav_item"><a href="/pro/oaov.html">办公云</a></li> -->
            <li class="cloud_nav_item">
              <a href="/platform-cloud/platformcloud.html">{{
                $t("footer.platform.cloud")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a href="/app/index.html">{{ $t("footer.mobile.terminal") }}</a>
            </li>
            <li class="cloud_nav_item">
              <a href="/sale-cloud/products-salespricing.html">{{
                $t("footer.versions.prices")
              }}</a>
            </li>
          </ul>
          <!-- 行业方案 -->
          <ul class="cloud_nav_list">
            <li class="cloud_nav_title">
              {{ $t("footer.industry.solutions") }}
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/solution/custom_good.html'">{{
                $t("footer.manufacturing")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/solution/education.html'">{{
                $t("footer.education.training")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/solution/itteck.html'">{{
                $t("footer.it.hightech")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/solution/goods.html'">{{
                $t("footer.city.operation")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/smbcrmpc/finance.html'">{{
                $t("footer.finance.industry")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/solution/healthcare.html'">{{
                $t("footer.medical.devices")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/solution/travel.html'">{{
                $t("footer.tourism.industry")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/solution/lawyer.html'">{{
                $t("footer.legal.industry")
              }}</a>
            </li>
          </ul>
          <!-- 服务支持 -->
          <ul class="cloud_nav_list">
            <li class="cloud_nav_title">{{ $t("footer.service.support") }}</li>
            <li class="cloud_nav_item">
              <a :href="url + '/partner/partner.html'">{{
                $t("footer.partners")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/service/PartnerSup.html'">{{
                $t("footer.partner.support")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a href="http://help.cloudcc.com/help.action">{{
                $t("footer.help.center")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/white-paper/index.html'">{{
                $t("footer.resource.center")
              }}</a>
            </li>
            <!-- <li class="cloud_nav_item"><a href="http://study.cloudcc.com/front/home.html">云动学院</a></li> -->
          </ul>
          <!-- 关于我们 -->
          <ul class="cloud_nav_list">
            <li class="cloud_nav_title">{{ $t("footer.about.us") }}</li>
            <li class="cloud_nav_item">
              <a :href="url + '/about/index.html'">{{
                $t("footer.company.introduction")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/news/index.html'">{{
                $t("footer.company.news")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/about/about-manage.html'">{{
                $t("footer.management.team")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/about/about-culture.html'">{{
                $t("footer.corporate.culture")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/about/about-devprogress.html'">{{
                $t("footer.development.history")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/about/about-honor.html'">{{
                $t("footer.qualifications.honors")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/about/about-brand.html'">{{
                $t("footer.brand.culture")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/about/about-join.html'">{{
                $t("footer.join.cloudcc")
              }}</a>
            </li>
            <li class="cloud_nav_item">
              <a :href="url + '/about/about-contactus.html'">{{
                $t("footer.contact.us")
              }}</a>
            </li>
          </ul>
        </nav>
        <!-- APP 下载 -->
        <div class="cloud_footer_App">
          <div class="cloud_App_title">APP下载</div>
          <div style="display: flex">
            <!-- 下载图标 -->
            <div class="cloud_App_QRCood" style="margin-right: 20px">
              <!-- 描述 -->
              <div class="cloud_App_QRCood_title">CloudCC CRM</div>
              <!-- 图片 -->
              <img class="app-code-img" src="./images/QRCood.jpg" alt="" />
            </div>
            <div class="cloud_App_QRCood">
              <!-- 描述 -->
              <div class="cloud_App_QRCood_title">CloudCC Sales</div>
              <!-- 图片 -->
              <img class="app-code-img" src="./images/Jump.png" alt="" />
            </div>
          </div>
          <!-- 手机商城的下载 app -->
          <div class="cloud_App">
            <!-- 描述 -->
            <div class="cloud_App_title">进入手机商城下载手机APP</div>
            <!-- 图片 -->
            <a href="#"
              ><img class="app-img" src="./images/ios_app_b.png" alt="" />
            </a>
            <a href="#"
              ><img class="app-img" src="./images/yinyongbao.png" alt="" />
            </a>
          </div>
        </div>
      </div>
      <div class="footerCopyright">
        <div class="copyrightBottom">
          <p>{{ $t("footer.telecom.license") }}</p>
          <p>{{ $t("footer.copyright") }}</p>
          <p>{{ $t("footer.developer") }}</p>
        </div>
        <div class="copyrightBottom">
          <p>
            <a
              href="https://beian.miit.gov.cn/#/Integrated/index"
              target="_blank"
              >{{ $t("footer.icp.registration") }}
            </a>
          </p>
          <p>{{ $t("footer.icp.certificate") }}</p>
          <p>{{ $t("footer.public.security") }}</p>
        </div>
      </div>
    </footer>
    <!-- PC端底部 -->
    <footer v-if="region == 'com'" ref="x-footer" class="hidden-md-and-down">
      <el-row class="pcRowOne">
        <el-col :offset="1" :xs="23" :sm="23" :md="4" :lg="3" :xl="3">
          <div
            class="logoin_img_box hidden-xs-only hidden-sm-only Bottom_unified_style"
          >
            <img src="./images/home-log.svg" alt="" />
          </div>
          <h4 class="hidden-xs-only hidden-sm-only" id="stayconnected">
            Stay connected with CloudCC
          </h4>
          <div class="Jump_img hidden-xs-only hidden-sm-only">
            <img
              @mouseover="changeOver('facebook1')"
              v-show="facebook1"
              src="./images/1.png"
              @click="changeFacebook"
            />
            <img
              @mouseout="changeOut('facebook1')"
              v-show="!facebook1"
              src="./images/2.png"
              @click="changeFacebook"
            />
            <img
              @mouseover="changeOver('facebook2')"
              v-show="facebook2"
              src="./images/3.png"
              @click="changetWitter"
            />
            <img
              @mouseout="changeOut('facebook2')"
              v-show="!facebook2"
              src="./images/4.png"
              @click="changetWitter"
            />
            <img
              @mouseover="changeOver('facebook3')"
              v-show="facebook3"
              src="./images/5.png"
              @click="changeYoutube"
            />
            <img
              @mouseout="changeOut('facebook3')"
              v-show="!facebook3"
              src="./images/6.png"
              @click="changeYoutube"
            />
            <img
              @mouseover="changeOver('facebook4')"
              v-show="facebook4"
              src="./images/7.png"
              @click="changeAuthwall"
            />
            <img
              @mouseout="changeOut('facebook4')"
              v-show="!facebook4"
              src="./images/8.png"
              @click="changeAuthwall"
            />
          </div>
        </el-col>

        <!-- 平台管理 -->
        <el-col
          :offset="2"
          :xs="10"
          :sm="6"
          :md="3"
          :lg="3"
          :xl="3"
          class="Bottom_unified_style"
        >
          <h3>Quick Links</h3>
          <div
            class="pinggu_management_box"
            style="list-style-type: none"
            v-for="(platformItem, index1) in crmCloudData"
            :key="index1"
          >
            <a
              :href="'https://www.cloudcc.com' + platformItem.path"
              target="_blank"
              class="list_style colorA"
              style="padding-top: 6px"
              >{{ platformItem.platformName }}</a
            >
          </div>
        </el-col>
        <!-- 教育行业 -->
        <el-col
          :offset="1"
          :xs="10"
          :sm="6"
          :md="3"
          :lg="3"
          :xl="3"
          class="Bottom_unified_style"
        >
          <h3>Products</h3>
          <div
            class="education_box"
            style="list-style-type: none"
            v-for="(educationItem, index2) in Products"
            :key="index2"
          >
            <a
              :href="'https://www.cloudcc.com' + educationItem.path"
              target="_blank"
              class="list_style colorA"
              style="padding-top: 6px"
              >{{ educationItem.educationName }}</a
            >
          </div>
        </el-col>
        <!-- 联系我们PC端和ipad样式 -->
        <el-col
          :offset="1"
          :xs="20"
          :sm="6"
          :md="3"
          :lg="4"
          :xl="2"
          class="Bottom_unified_style hidden-xs-only"
        >
          <h3>Contact Us</h3>
          <div
            class="Contact_Us_box"
            style="list-style-type: none"
            v-for="(contactUsItem, index3) in contactUsData"
            :key="index3"
          >
            <a
              href="mailto:support@cloudcc.com"
              v-if="contactUsItem.id == 'Email'"
              >{{ contactUsItem.contactUsName }}</a
            >
            <li
              v-else
              class="list_style"
              style="padding-top: 6px"
              @click="supportCenter(contactUsItem.id)"
            >
              {{ contactUsItem.contactUsName }}
            </li>
          </div>
        </el-col>

        <el-col :offset="1" :xs="24" :sm="24" :md="4" :lg="3" :xl="2">
          <div
            class="download_method_img_app hidden-xs-only hidden-sm-only Bottom_unified_style"
            style="padding-left: 20px"
          >
            <img
              @mouseover="changeOver('facebook5')"
              v-show="facebook5"
              src="./images/home-apple1.png"
              alt=""
            />
            <img
              @mouseout="changeOut('facebook5')"
              v-show="!facebook5"
              @click="changeApple"
              src="./images/home-apple2.png"
              alt=""
            />
            <img
              @mouseover="changeOver('facebook6')"
              v-show="facebook6"
              src="./images/home-google1.png"
              alt=""
            />
            <img
              @mouseout="changeOut('facebook6')"
              v-show="!facebook6"
              @click="changeGoogle"
              src="./images/home-google2.png"
              alt=""
            />
          </div>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <div class="bottom">
        <el-row class="pcRowTwo">
          <el-col :offset="3" :xs="12" :sm="12" :md="17" :lg="17" :xl="17">
            <div class="explain_box hidden-xs-only hidden-sm-only">
              <span class="list_style" @click="toShou()">CloudCC Home</span>
              <span>|</span>
              <span class="list_style" @click="jumpPolicy">Privacy Policy</span>
              <span>|</span>
              <span class="list_style" @click="jumpTerm">Terms of Service</span>
              <span>|</span>
              <span class="list_style" @click="jumpSecurity">Security Statement</span>
              <span>|</span>
              <span class="list_style" @click="jumpCookie">Cookie Policy</span>
              <span>|</span>
              <span class="list_style" @click="jumpGDPR">GDPR Compliance</span>
            </div>
            <!-- 版本信息 -->
            <div class="edition_box hidden-xs-only hidden-sm-only">
              <span class="version_information">
                © {{ year }},CloudCC Inc. All Rights Reserved.</span
              >
            </div>
          </el-col>
        </el-row>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 域名
      url: window.Glod["ccex-cloudcc"],
      // 客户管理平台数据
      crmCloudData: [
        {
          id: "AboutCC",
          platformName: "About CloudCC",
          path: "/about/about-us/",
        },
        {
          id: "Why",
          platformName: "Why CloudCC",
          path: "/company/why-cloudcc/",
        },
        {
          id: "GDPR",
          platformName: "GDPR Compliance",
          path: "/company/gdpr/",
        },
        {
          id: "Privacy",
          platformName: "Privacy Policy",
          path: "/company/privacy/",
        },
        {
          id: "security",
          platformName: "Terms of Service",
          path: "/company/terms/",
        },
        {
          id: "Date",
          platformName: "Security Statement",
          path: "/company/security-statement/",
        },
        {
          id: "Pric",
          platformName: "Pricing",
          path: "/pricing/crm/",
        },
      ],
      // 教育列数据
      Products: [
        {
          id: "Faculty",
          path: "/products/sales/",
          educationName: "Sales",
        },
        {
          id: "BI",
          path: "/products/bi/",
          educationName: "BI Analysis",
        },
        {
          id: "Admissions",
          path: "/products/marketing/",
          educationName: "Marketing",
        },
        {
          id: "Portal",
          path: "/products/service/",
          educationName: "Service",
        },
        {
          id: "K",
          path: "/products/project/",
          educationName: "Project",
        },
        {
          id: "Learning",
          path: "/products/partner/",
          educationName: "Partner",
        },
        {
          id: "C",
          path: "/products/cpq/",
          educationName: "CPQ",
        },
        {
          id: "Plat",
          path: "/products/platform/",
          educationName: "Platform",
        },
        {
          id: "Mobile",
          path: "/products/mobile-app/",
          educationName: "Mobile App",
        },
      ],
      // 联系我们
      contactUsData: [
        {
          id: "Email",
          contactUsName: "Email: support@us.cloudcc.com",
        },
        {
          id: "Call",
          contactUsName: "Call: +1 801-997-0088",
        },
        // {
        //   id: "Wyatt",
        //   contactUsName: this.$i18n.t("website.footer.contact1600"),
        // },
        {
          id: "Support",
          contactUsName: "Support Center",
        },
      ],
      facebook1: true,
      facebook2: true,
      facebook3: true,
      facebook4: true,
      facebook5: true,
      facebook6: true,
      year: "",
    };
  },
  computed: {
    // 根据域名判断是国内还是国外：cn 为国内，com 为国外
    region() {
      const host = window.location.hostname;
      if (host.includes(".cn")) return "cn";
      if (host.includes(".com")) return "com";
      return "com";
    },
  },
  created() {
    this.time();
  },
  methods: {
    // 动态获取页面最底部年
    time() {
      var t = new Date();
      this.year = t.getFullYear();
    },
    changeOver(val) {
      if (val === "facebook1") {
        this.facebook1 = false;
      } else if (val === "facebook2") {
        this.facebook2 = false;
      } else if (val === "facebook3") {
        this.facebook3 = false;
      } else if (val === "facebook4") {
        this.facebook4 = false;
      } else if (val === "facebook5") {
        this.facebook5 = false;
      } else if (val === "facebook6") {
        this.facebook6 = false;
      }
    },
    changeOut(val) {
      if (val === "facebook1") {
        this.facebook1 = true;
      } else if (val === "facebook2") {
        this.facebook2 = true;
      } else if (val === "facebook3") {
        this.facebook3 = true;
      } else if (val === "facebook4") {
        this.facebook4 = true;
      } else if (val === "facebook5") {
        this.facebook5 = true;
      } else if (val === "facebook6") {
        this.facebook6 = true;
      }
    },
    supportCenter(val) {
      if (val == "Support") {
        window.open("https://help-en.cloudcc.com");
      } else {
        return;
      }
    },
    // 底部四个社交媒体
    changeFacebook() {
      window.open(
        "https://www.facebook.com/login/?next=https%3A%2F%2Fwww.facebook.com%2FCloudcc-1139805309505007%2F"
      );
    },
    changetWitter() {
      window.open("https://twitter.com/CloudCC_CRM");
    },
    changeYoutube() {
      window.open("https://www.youtube.com/channel/UCt2_f34aXax7TzYf9kK2gGQ");
    },
    changeAuthwall() {
      window.open(
        "https://www.linkedin.com/authwall?trk=ripf&trkInfo=AQERHnNWDeluJAAAAXqKOMxAZg0nZlrBZK88hguUt267Ib962dJ2J6PAoOyJT0o1o-0kDuh3UNvXJ9nLjADU1NResuA-Ba7FrFy7w6GQD6PwAlSmSSP1tWa3BsIrPKC09z38YBo=&originalReferer=http://www-ustest.cloudcc.com/&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fcloudcc-inc%2F%3FviewAsMember%3Dtrue"
      );
    },
    // apple google 跳转
    changeApple() {
      window.open(
        "https://itunes.apple.com/us/app/cloudcc-crm/id854886241?mt=8"
      );
    },
    changeGoogle() {
      window.open(
        "https://play.google.com/store/apps/details?id=com.cloudcc.mobile"
      );
    },
    // 底部静态链接
    toShou() {
      window.open("https://cloudcc.com/");
    },
    jumpPolicy() {
      window.open("https://cloudcc.com/company/privacy");
    },
    jumpTerm() {
      window.open("https://cloudcc.com/company/terms");
    },
    jumpSecurity() {
      window.open("https://cloudcc.com/company/security-statement");
    },
    jumpCookie() {
      window.open("https://cloudcc.com/company/cookie-policy");
    },
    jumpSitemap() {
      window.open("https://cloudcc.com/sitemap");
    },
    jumpGDPR() {
      window.open("https://cloudcc.com/company/gdpr");
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-box {
  width: 100%;
  min-height: 200px;
}

.cloud_footer_box {
  width: 100%;
  color: #fff;

  .cloud_footer {
    width: 100%;
    padding: clamp(40px, 8vh, 80px) 0 clamp(30px, 6vh, 60px) 0;
    background: #374761;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: flex-start;
    gap: clamp(20px, 4vw, 40px);

    .cloud_footer_logo {
      flex: 1;
      min-width: 250px;
      max-width: 300px;

      .logo-content {
        margin-top: 20px !important;
        width: 100%;
        margin: auto;
        display: flex;
        align-items: center;
        flex-direction: column;
        text-align: center;

        .logo-code {
          width: clamp(120px, 25vw, 150px);
          margin-top: clamp(25px, 5vh, 50px);
        }

        p {
          font-size: clamp(14px, 3vw, 18px);
          margin-top: 12px;
        }

        img {
          width: 80%;
          object-position: center;
        }
      }
    }

    .cloud_footer_nav {
      flex: 2;
      min-width: 400px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      gap: clamp(15px, 3vw, 30px);

      .cloud_nav_list {
        flex: 1;
        min-width: 120px;
        text-align: center; // 添加整体居中样式

        .cloud_nav_title {
          font-size: clamp(14px, 3vw, 18px);
          padding-bottom: 10px;
          font-weight: bold;
        }

        .cloud_nav_item {
          height: clamp(25px, 5vh, 30px);
          line-height: clamp(25px, 5vh, 30px);
          font-size: clamp(12px, 2.5vw, 14px);

          a {
            color: #fff;
            text-decoration: none;

            &:hover {
              color: #006dcc;
            }
          }
        }
      }
    }

    .cloud_footer_App {
      flex: 1;
      min-width: 250px;
      max-width: 300px;

      .cloud_App_title {
        font-size: clamp(14px, 3vw, 18px);
        padding: clamp(12px, 2.5vh, 16px) 0px;
      }

      .app-code-img {
        width: 80px;
        margin-top: 20px;
      }

      .app-img {
        width: 150px;
      }
      a {
        display: block;
      }
    }
  }

  .footerCopyright {
    width: 100%;
    background: #161c2b;
    padding: clamp(15px, 3vh, 20px) 0;
    font-size: clamp(10px, 2.5vw, 12px);
    box-sizing: border-box;
    flex-shrink: 0;

    .copyrightBottom {
      margin-top: clamp(8px, 1.5vh, 12px);
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: clamp(10px, 2vw, 20px);

      p {
        margin: 0;
        text-align: center;

        a {
          color: #fff;
          text-decoration: none;

          &:hover {
            color: #006dcc;
          }
        }
      }
    }
  }
}

// 大盒子
.hidden-md-and-down {
  width: 100%;
  background: #fafafa;

  // pc端底部1
  .pcRowOne {
    max-width: 1440px;
    margin: 0 auto;
    padding: 4px 0 20px 0;
    display: flex;
    justify-content: center;
  }
  @media screen and (max-width: 1920px) {
    .pcRowOne {
      max-width: 1560px;
    }
  }
  // 线
  .el-divider--horizontal {
    margin: 0 !important;
  }
  // pc端底部2
  .bottom {
    background: #f1f1f1;
    .pcRowTwo {
      max-width: 1280px;
      margin: 0 auto;
      padding: 15px 0;
      .language_switching_box {
        height: 42px;
        .el-menu.el-menu--horizontal {
          padding: 0 !important;
          background: #f1f1f1;
        }
      }
    }
  }

  // 下载appStore部分
  .download_method_img_app {
    img {
      width: 80%;
      cursor: pointer;
    }
  }
  .download_method_img_google {
    img {
      width: 100%;
    }
  }
  // pc端
  .Jump_img {
    display: flex;
    justify-content: center;
    img {
      padding-right: 5px;
      width: 42px;
      height: 35px;
      cursor: pointer;
    }
  }
  .introduce_box {
    .dow_img {
      display: flex;
      justify-content: space-evenly;
      width: 100%;
      padding: 20px 0;
      // border-width: 0 0 1px 0;
      // border-style: solid;
      // border-color: #808080;
      .img1 {
        width: 30%;
        img {
          width: 100%;
        }
      }
    }
  }

  .introduce {
    padding: 8px 20px;
    color: #333333;
    font-size: 14px;
    // line-height: 40px;
    display: block;
  }
  .download_link {
    background: #f1f1f1;
  }
  .contact_information {
    background: #f1f1f1;
    border-width: 0 0 1px 0;
    border-style: solid;
    border-color: #e4e4e4;
    .stayconnected {
      padding: 20px 20px;
      font-weight: bold;
      color: #010101;
      font-size: 16px;
    }
    .facebook_box {
      display: flex;
      padding: 0 15px 20px;
      div {
        width: 5%;
        padding: 0 5px;
        img {
          width: 100%;
        }
      }
    }
  }
  .mode_box {
    background: #f1f1f1;
    border-width: 0 0 1px 0;
    border-style: solid;
    border-color: #e4e4ee;
    padding-bottom: 10px;
    .contactus {
      padding: 20px 20px 7px;
      font-weight: bold;
      color: #010101;
      font-size: 16px;
      text-transform: uppercase;
    }
    .message {
      div {
        padding: 5px 20px;
        span {
          padding-left: 5px;
        }
      }
    }
  }
  .switch_search {
    .variables {
      border-width: 0 0 1px 0;
      border-style: solid;
      border-color: #e4e4e4;
      background: #fff;
    }
    .on_trial {
      background: #ffffff;
      padding: 30px 0;
      .input_box {
        width: 90%;
        margin: 0 auto;
      }
    }
  }
  .copyright {
    text-align: center;
    padding: 20px 0;
    .cop_text {
      font-size: 12px;
    }
  }
  .btn_warning {
    text-align: center;
    position: fixed;
    bottom: 10px;
    width: 100%;
  }

  #stayconnected {
    text-align: center;
    padding: 30px 0;
  }
  .Jump_img_MC {
    display: flex;
    justify-content: center;
    padding: 21px 0px 22px 0;
  }
  // 移动端的logo图片
  .move_logoin_img_box {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 20px;
  }
  // 移动端下载处图片
  .move_method_img_app {
    img {
      width: 100%;
    }
  }
  // 底部统一样式
  .Bottom_unified_style {
    padding-top: 15px;
    h3 {margin-top: 0px;}
    .Contact_Us_box {
      a {
        color: black;
      }
      a:hover {
        color: #00bfff;
      }
    }
  }
  // 列表鼠标划上小手样式
  .list_style {
    cursor: pointer;
  }
  .list_style:hover {
    color: #00bfff;
  }
  // 政策说明字体样式
  .explain_box {
    text-align: center;
    span {
      font-size: 12px;
      color: #999999;
      padding-left: 3px;
      cursor: pointer;
    }
  }
  // 版本信息样式
  .edition_box {
    text-align: center;
    .version_information {
      font-size: 12px;
      color: #999999;
    }
  }
}
</style>